import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const environmentInterceptor: HttpInterceptorFn = (req, next) => {
  console.log('Environment Interceptor',environment);
  // Si la URL ya es absoluta, no tocarla
  if (/^https?:\/\//i.test(req.url)) {
    return next(req);
  }

  const base = environment?.api ? String(environment.api) : '';
  if (!base) {
    return next(req);
  }

  const baseClean = base.replace(/\/+$/g, ''); // quitar slash final
  const path = req.url.replace(/^\/+/g, ''); // quitar slash inicial
  const newUrl = `${baseClean}/${path}`;

  const cloned = req.clone({ url: newUrl });
  return next(cloned);
};